import { createLotoReportDraft } from './lotoReportDraft'
import type {
  LotoReport,
  LotoReportEntry,
  LotoReportScope,
} from './lotoReportSchemas'
import { matchesLotoScope } from './lotoReportScope'
import { applyTargetEquipment } from './lotoTargetEquipment'

export function lotoEntryFromProposal(
  scope: LotoReportScope,
  proposal: LotoReport,
  retryDraft?: LotoReportEntry
): LotoReportEntry {
  if (retryDraft && matchesLotoScope(retryDraft.tags, scope)) return retryDraft
  const draft = createLotoReportDraft(scope, proposal.name)
  const data = { ...proposal, created_at: draft.data.created_at }
  return { ...draft, data: applyTargetEquipment(data, data.target_equipment) }
}
